import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

export function FloorMapSkeleton() {
  return (
    <div className="flex flex-col gap-4 lg:flex-row">

      {/* LEFT: MAP */}
      <div className="flex-1">
        <Card>
          <CardHeader className="pb-3">
            <div className="flex flex-col gap-3">

              {/* Title + floors */}
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <Skeleton className="h-4 w-48" />

                <div className="flex gap-2">
                  <Skeleton className="h-8 w-12" />
                  <Skeleton className="h-8 w-12" />
                  <Skeleton className="h-8 w-12" />
                </div>
              </div>

              {/* Controls */}
              <div className="flex justify-between">
                <div></div>

                <div className="flex gap-2">
                  <Skeleton className="h-8 w-20" />
                  <Skeleton className="h-8 w-20" />
                </div>
              </div>
            </div>
          </CardHeader>

          <CardContent className="flex justify-center">
            {/* Map area — IMPORTANT fixed height */}
            <Skeleton className="w-full h-[400px]" />
          </CardContent>
        </Card>
      </div>

      {/* RIGHT: SIDE PANEL */}
      <div className="w-full lg:w-72">
        <div className="flex flex-col gap-4">

          {/* Floor summary */}
          <Card className="border-border/50 bg-card">
            <CardContent className="p-4">
              <Skeleton className="h-4 w-32 mb-4" />

              <div className="flex flex-col gap-3">
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-3 w-full" />
              </div>
            </CardContent>
          </Card>

        </div>
      </div>
    </div>
  )
}